export const ActionRowSetup = {
  showNow: false,
  showPreview: false,
  showCancel: false,
  showSelect: false
};
export interface DateFilterSelectEvent {
  start: string;
  end: string;
};